import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import type { DialogHTMLAttributes } from "vue"
import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import Icon from "./Icon"
import Modal from "./Modal"

interface Props {
	title: string
	onClose(): void
	zIndex?: number
}

const closeButtonStyles = css`
	color: var(--bs-secondary);
	border: none;
	padding: 0;
	margin: 0;
	outline: none;
	background: transparent;

	&:hover {
		color: #303030;
	}

	svg {
		height: 1.5rem;
	}
`

const CloseableModal: ReactiveComponent<Props, DialogHTMLAttributes> = (props, { attrs, slots }) => {
	return () => (
		<Modal
			zIndex={props.zIndex}
			onCancel={(e) => {
				e.preventDefault()
				props.onClose()
			}}
			{...attrs}
		>
			<div class="d-flex justify-content-between">
				<h5 class="mb-0">{props.title}</h5>
				<button class={closeButtonStyles} type="button" title="Close" onClick={props.onClose}>
					<Icon icon={faXmarkCircle} cursor="pointer" />
				</button>
			</div>
			<hr />
			{renderSlot(slots)}
		</Modal>
	)
}

export default defineComponent(CloseableModal, inferProps<Props>())
